(function () {
    new Ajaxinate({
        method: "scroll",
        container: "#blogContainer",
        pagination: "#blogPagination"
    });

    const blogBody = document.querySelector('.blog__body-wrap');

    if(blogBody){
        var path = window.location.pathname;
        document.querySelector('.blog--button-back').style.display = path.includes("tagged") ? "block" : "none";
    }
})();
